import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import ggAddress, { AddressComponent_Item as AddressComponentItem } from 'ggApp/modules/address';
import ggStore from 'ggApp/modules/store';
import ggPayment from 'ggApp/modules/payment';
import ggAuth from 'ggApp/modules/auth';
import { LayoutComponent_Checkout_Add as LayoutComponentCheckoutAdd } from 'ggApp/modules/layout';
import ggOrder from 'ggApp/modules/order';
import ggAdyen from 'ggApp/modules/adyen';
import ggRouter from 'ggApp/modules/router';

import OrderVoucherConnect from 'ggApp/shared/containers/order/voucher';
import { PaymentGatewayList } from 'ggApp/shared/common/Payment/PaymentGatewayList';
import { PAYMENT_SERVICE_METHOD_TYPE } from 'ggApp/utils/detectPayment';

import PaymentScreenWrapper from './ScreenWrap';
import { Summary } from './styles';

@connect(
    createStructuredSelector({
        user: ggAuth.selectors.user,
        order: ggOrder.selectors.orderActive,
        addressList: ggAddress.selectors.addressList,
        addressActiveShippingId: ggAddress.selectors.activeAddressShippingId,
        addressActiveBillingId: ggAddress.selectors.activeAddressBillingId,
        addressActiveBilling: ggAddress.selectors.activeAddressBilling,
        store: ggStore.selectors.storeActive,
    }),
    (dispatch) => ({
        adyenActions: bindActionCreators(ggAdyen.actions, dispatch),
        routerActions: bindActionCreators(ggRouter.actions, dispatch),
        orderActions: bindActionCreators(ggOrder.actions, dispatch),
        paymentActions: bindActionCreators(ggPayment.actions, dispatch),
    }),
)
export default class CreatePaymentScreen extends Component {
    componentWillMount() {
        const { routerActions, adyenActions } = this.props;
        const { order, user } = this.props;

        if (order.shipping_address_id === null || !user.phone_verified) {
            routerActions.transitionTo('/checkout/address');
            return;
        }

        adyenActions.savePaymentData('', {});
    }

    onPaymentMethodCreated = (paymentMethodId) => {
        const { order, paymentActions, orderActions } = this.props;
        if (paymentMethodId) {
            // 'updateOrder' does not return a promise
            orderActions.updateOrder({
                current_payment_source_id: paymentMethodId,
                current_payment_source_type: PAYMENT_SERVICE_METHOD_TYPE,
            });
            return orderActions
                .updateOrderPaymentMethod(
                    order.number,
                    paymentMethodId,
                    PAYMENT_SERVICE_METHOD_TYPE,
                )
                .then(() => paymentActions.getPaymentMethodsByUser());
        }

        return Promise.reject(new Error('Cannot proceed without paymentMethodId'));
    };

    onLegacyPaymentMethodCreated = (result) => {
        const { paymentActions } = this.props;
        if (result) {
            paymentActions.getPaymentMethodsByUser();
        }
    };

    render() {
        const {
            addressActiveShippingId,
            addressActiveBillingId,
            addressActiveBilling,
            addressList,
            order,
        } = this.props;
        const billingAddressCondition =
            addressActiveShippingId === addressActiveBillingId ||
            addressActiveBillingId === null ||
            !addressActiveBilling;
        const modalAddressSuccessUrl = encodeURIComponent('/checkout/payment');
        const addressAddUrl = `/checkout/payment?modal=address-create&modal-address-type=billing&modal-address-success-url=${modalAddressSuccessUrl}`;
        const modalAddressAddUrl = encodeURIComponent(addressAddUrl);
        const additionalComponents = (
            <>
                {!billingAddressCondition && (
                    <AddressComponentItem
                        noEdit
                        title="BILLING_ADDRESS"
                        active
                        onClick={() => {}}
                        address={addressActiveBilling}
                    />
                )}
                <LayoutComponentCheckoutAdd
                    text={billingAddressCondition && 'SAME_ADDRESSES'}
                    linkText="ADD_NEW_ADDRESS"
                    to={
                        addressList.length > 1
                            ? `/checkout/payment?modal=address-select&modal-address-type=billing&modal-address-add-url=${modalAddressAddUrl}`
                            : addressAddUrl
                    }
                />
                <OrderVoucherConnect order={order} />
                <Summary
                    order={{
                        currencySymbol: order.currencySymbol,
                        subtotal: order.item_total,
                        shipping: order.shipment_total,
                        voucherDiscount: order.voucher && order.voucher.discount,
                        total: order.total,
                    }}
                />
            </>
        );

        return (
            <PaymentScreenWrapper>
                <PaymentGatewayList
                    orderNumber={order.number}
                    onPaymentMethodCreated={this.onPaymentMethodCreated}
                    onLegacyPaymentMethodCreated={this.onLegacyPaymentMethodCreated}
                >
                    {additionalComponents}
                </PaymentGatewayList>
            </PaymentScreenWrapper>
        );
    }
}
